import React from 'react';

const Close = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 16.428L21.3502 22.7782C21.7444 23.1727 22.384 23.1727 22.7782 22.7782C23.1727 22.3837 23.1727 21.7448 22.7782 21.3502L16.428 15L22.7782 8.64952C23.1727 8.25499 23.1727 7.61606 22.7782 7.22153C22.384 6.827 21.7444 6.827 21.3502 7.22153L15 13.5721L8.64984 7.22153C8.25565 6.827 7.61605 6.827 7.22186 7.22153C7.02493 7.4188 6.92629 7.67733 6.92629 7.93553C6.92629 8.19372 7.02493 8.45225 7.22219 8.64952L13.5724 15L7.22219 21.3502C7.02493 21.5475 6.92629 21.806 6.92629 22.0642C6.92629 22.3224 7.02493 22.581 7.22219 22.7782C7.61639 23.1728 8.25598 23.1727 8.65018 22.7782L15 16.428Z" fill="#E8E8E8" />
  </svg>
);

export default Close;
